import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Initialize theme
const savedTheme = localStorage.getItem('theme') || 'dark';
document.documentElement.setAttribute('data-theme', savedTheme);

// Определение Telegram Mini App и применение адаптации для fullscreen
const isTelegramWebApp = () => {
  return typeof window !== 'undefined' && 
         (window.Telegram?.WebApp !== undefined || 
          window.location.href.includes('telegram.org') ||
          navigator.userAgent.includes('Telegram'));
};

// Применение адаптации для Telegram Mini App
if (isTelegramWebApp()) {
  document.documentElement.classList.add('telegram-miniapp');
  
  // Инициализация Telegram WebApp API если доступен
  if (window.Telegram?.WebApp) {
    const tg = window.Telegram.WebApp;
    tg.expand(); // Разворачиваем на весь экран
    tg.enableClosingConfirmation(); // Включаем подтверждение закрытия
    
    // Устанавливаем цвет фона и header (прозрачный, чтобы использовать наш кастомный header)
    tg.setHeaderColor('transparent');
    tg.setBackgroundColor('#121212');
    
    // Скрываем стандартную кнопку закрытия Telegram, так как у нас своя панель
    // tg.BackButton.hide();
  }
  
  // Добавляем класс для дополнительных стилей
  document.body.classList.add('telegram-fullscreen');
}

// Apply background images based on theme
const applyBackground = (theme) => {
  const body = document.body;
  const publicUrl = process.env.PUBLIC_URL || '';
  const darkBg = `${publicUrl}/backgrounds/background-dark.png`;
  const lightBg = `${publicUrl}/backgrounds/background-light.png`;
  const bgUrl = theme === 'light' ? lightBg : darkBg;

  body.style.backgroundImage = `url(${bgUrl})`;
  body.style.backgroundSize = 'cover';
  body.style.backgroundPosition = 'center';
  body.style.backgroundRepeat = 'no-repeat';
  body.style.backgroundAttachment = 'fixed';

  // #mobile-bg — фиксированный фон-слой для мобильных (iOS Safari не поддерживает background-attachment:fixed)
  const mobileBg = document.getElementById('mobile-bg');
  if (mobileBg) {
    mobileBg.style.cssText = 'position:fixed;top:-5vh;left:-5vw;width:110vw;height:110vh;z-index:-1;pointer-events:none;background-size:cover;background-position:center;background-repeat:no-repeat;';
    mobileBg.style.backgroundImage = `url(${bgUrl})`;
  }

  const dashboardMain = document.querySelector('.dashboard-main');
  if (dashboardMain) {
    dashboardMain.style.backgroundImage = `url(${bgUrl})`;
    dashboardMain.style.backgroundSize = 'cover';
    dashboardMain.style.backgroundPosition = 'center';
    dashboardMain.style.backgroundRepeat = 'no-repeat';
    dashboardMain.style.backgroundAttachment = 'fixed';
  }

  const statisticsContainers = document.querySelectorAll(
    '.statistics-mrp-container, .statistics-junior-container'
  );
  statisticsContainers.forEach(container => {
    container.style.backgroundImage = `url(${bgUrl})`;
    container.style.backgroundSize = 'cover';
    container.style.backgroundPosition = 'center';
    container.style.backgroundRepeat = 'no-repeat';
    container.style.backgroundAttachment = 'fixed';
  });
};

// Apply initial background
applyBackground(savedTheme);

// Listen for theme changes and DOM changes
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'data-theme') {
      const theme = document.documentElement.getAttribute('data-theme');
      applyBackground(theme);
    }
    // Also check if dashboard-main was added
    if (mutation.type === 'childList' || mutation.type === 'subtree') {
      const theme = document.documentElement.getAttribute('data-theme');
      applyBackground(theme);
    }
  });
});

observer.observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['data-theme'],
  childList: true,
  subtree: true
});

// Also periodically check for dashboard-main and statistics containers (in case they load later)
const checkInterval = setInterval(() => {
  const dashboardMain = document.querySelector('.dashboard-main');
  const statisticsContainers = document.querySelectorAll(
    '.statistics-mrp-container, .statistics-junior-container'
  );
  if (dashboardMain || statisticsContainers.length > 0) {
    const theme = document.documentElement.getAttribute('data-theme');
    applyBackground(theme);
  }
}, 100);

// Clear interval after 10 seconds to avoid infinite checking
setTimeout(() => clearInterval(checkInterval), 10000);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

